/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { ActionContext, Module } from 'vuex';
import store from '@/store';
import RootStateType from '@/store/types';
import generateMutations, {
  UPDATE_STATE_TYPE,
} from '@/store/generate-mutations';
import OrdersApi from '@/api/ordersV2';
import { StateType } from './types';

const storeModule: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    orderDetail: null,
    commodityDetail: null,
    channelList: [],
    planListData: undefined,
    showMoreCapitalInfo: false,
  },
  actions: {
    // 提现申请进度
    async getApplyResult(
      context: ActionContext<StateType, RootStateType>,
      payload: { orderId: string; showLoading?: boolean },
    ): Promise<void> {
      const { orderId, showLoading } = payload;
      try {
        const { loanOrderVo, commodityDetailVO, showMoreCapitalInfo } = await OrdersApi.queryOrder(
          orderId,
          showLoading,
        );

        await context.dispatch(UPDATE_STATE_TYPE, {
          orderDetail: loanOrderVo,
          commodityDetail: commodityDetailVO,
          showMoreCapitalInfo,
        });


        return Promise.resolve();
      } catch (error) {
        return Promise.resolve();
      }
    },
  },
};

store.registerModule('applyResult', generateMutations(storeModule));
